var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"m4",on:{"mouseover":function($event){_vm.show = 'copy'}}},[_c('a',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.$copyText(_vm.str); _vm.settext('copied!')}}},[_c('i',{staticClass:"fa fa-copy fa-sm"}),_vm._v(" "+_vm._s(_vm.show))])])
}
var staticRenderFns = []

export { render, staticRenderFns }